<div class="bn-dialog bn-extend-trial p-2 pb-0">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg" />
  </div>
  <div class="bn-dialog__body">
    @if (isSuccess) {
      <ng-template [ngTemplateOutlet]="successScreen" />
    }
    @if (!FreeTrialExtendedDate && !isSuccess) {
      @if (isAutoExtend) {
        @if (isLoading) {
          <bn-web-ui-loading [isTransparent]="true" />
        }
      } @else {
        <div class="row">
          <div class="col-6 d-none d-md-block">
            <div class="bn-extend-trial__title ms-6">Extend your Free Trial for Additional 14-days!</div>
            <img
              class="bn-extend-trial__image"
              src="/assets/images/bunny-14-days-extra.svg" />
          </div>
          <div class="col-12 col-md-6">
            <div class="bn-extend-trial__title d-block d-md-none text-center text-md-left ms-md-6">Extend your Free Trial for Additional 14-days!</div>
            <div class="bn-extend-trial__content">
              <div class="bn-extend-trial__content__title">Ready for more bunny.net goodness?</div>
              <p>
                Click that button below and watch the magic happen! We're giving you an extra 14 days to dive into the wild world of bunny.net.
                <br />
                <br />
                But here's the twist: this 14-day boost won't give you super-sized bandwidth. It's all about extending the fun and excitement of your trial. So
                go ahead, click, and let the bunny.net adventure continue!
              </p>
              <hr class="mt-3 mb-4" />
              <div>
                <div class="row">
                  <div class="col-6">
                    <fa-duotone-icon
                      class="bn-extend-trial__usage__item__icon"
                      size="lg"
                      [icon]="['fad', 'circle-dollar']" />
                    <div class="bn-extend-trial__usage__item__value">
                      {{ usedTrialBalance ? (usedTrialBalance | currency: APP_CONFIG.currencySymbol : undefined : '1.2') : APP_CONFIG.currencySymbol + '0.00' }}
                      /
                      {{
                        totalTrialBalance ? (totalTrialBalance | currency: APP_CONFIG.currencySymbol : undefined : '1.2') : APP_CONFIG.currencySymbol + '0.00'
                      }}
                    </div>
                    <div>Trial usage</div>
                  </div>
                  <div class="col-12 my-3">
                    <div class="bn-extend-trial__usage__progress-bar">
                      <div
                        class="bn-extend-trial__usage__progress-bar__cover"
                        [style.width]="100 - (totalTrialBalance ? (usedTrialBalance / totalTrialBalance) * 100 : 0) + '%'"></div>
                    </div>
                  </div>
                </div>
                <div>You spent {{ (totalTrialBalance ? (usedTrialBalance / totalTrialBalance) * 100 : 0) | number: '1.2-2' }} % of your limit.</div>
              </div>
              <hr class="mt-3" />
              <div class="bn-dialog__actions mt-5">
                <button
                  bn-web-ui-button
                  itemStyle="primary"
                  size="lg"
                  [fullWidth]="true"
                  [loading]="isLoading"
                  (click)="onExtendTrialClick()">
                  Extend Your Free Trial
                </button>
              </div>
              @if (isError) {
                <bn-web-ui-alert
                  alertType="danger"
                  class="text-start mt-2"
                  headerIcon="circle-exclamation"
                  [showIcon]="true">
                  Something went wrong, please try later!
                </bn-web-ui-alert>
              }
            </div>
          </div>
        </div>
      }
    }
    @if (FreeTrialExtendedDate && !isSuccess) {
      <div class="text-center">
        <div class="bn-extend-trial__title">Trial Already Extended</div>
        <div class="bn-extend-trial__success__text mb-6">Your trial was already extended on {{ FreeTrialExtendedDate | date }}</div>
        <img src="/assets/images/bunny-free-trial-extended.svg" />
      </div>
    }
  </div>
</div>
<ng-template #successScreen>
  <div class="text-center">
    <div class="bn-extend-trial__title">Congratulations!</div>
    <div class="bn-extend-trial__success__text mb-6">Your Free Trial has been Extended.</div>
    <img src="/assets/images/bunny-free-trial-extended.svg" />
  </div>
</ng-template>
